import { Button, Col, FormCheck, Modal, Row } from 'react-bootstrap'
import LabelRequired from '../../../component/LabelRequired'
import { Form, Formik } from 'formik';
import TextField from '../../../component/TextField';
import DatePickerCustom from '../../../component/date-picker/DatePickerCustom';
import ProvisonalDiagnosis from '../../components/ProvisonalDiagnosis';
import { useState } from 'react';
import AutocompleteV2 from '../../../component/AutocompleteObjectV2';
import { getInpatientCategory } from '../../../phan-he-noi-tru/services/Common';
import { categoryCode } from '../../../phan-he-noi-tru/const/PhanHeNoitruConst';
import * as Yup from 'yup';
import { MESSAGE } from '../../../utils/Constant';
import ParaclinicalSummaryField from '../../components/tab-kham-benh/modal-chon-ket-qua-dich-vu/ParaclinicalSummaryField';

type Props = {
  show: boolean;
  handleCloseDialog: () => void;
  handleSubmit?: (values: any) => void;
  patientInfo?: any;
}

const ModalCapNhatThongTinTuVong = ({ show, handleCloseDialog, handleSubmit, patientInfo }: Props) => {
  const [listComorbidity, setListComorbidity] = useState<any[]>([]);
  
  const validationSchema = Yup.object().shape({
      tuVongNgay: Yup.string().required(MESSAGE.REQUIRED).nullable(),
      tuVongThoiGian: Yup.object().required(MESSAGE.REQUIRED).nullable(),
      tuVongNguyenNhan: Yup.object().required(MESSAGE.REQUIRED).nullable(),
  });

  const handleFormSubmit = (values: any) => {
    const {
      tuVongThoiGian,
      tuVongNguyenNhan,
      tuVongNguyenNhanChinh,
      tuVongChanDoanGiaiPhau,
      ...otherFormValues
	  } = values;

    const submitData = {
        ...otherFormValues,
        tuVongThoiGianCode: tuVongThoiGian?.code,
        tuVongThoiGianName: tuVongThoiGian?.name,
        tuVongNguyenNhanCode: tuVongNguyenNhan?.code,
        tuVongNguyenNhanName: tuVongNguyenNhan?.name,
        tuVongNguyenNhanChinhCode: tuVongNguyenNhanChinh,
        tuVongChanDoanGiaiPhauCode: tuVongChanDoanGiaiPhau
    };
    
    handleSubmit?.(submitData);
  };

  return (
    <Modal centered show={show} size="xl" onHide={handleCloseDialog} scrollable>
      <Modal.Header closeButton>
        <Modal.Title>
          Cập nhật thông tin tử vong
        </Modal.Title>
      </Modal.Header>

      <Formik<any>
        initialValues={{
          tuVongDaCapGiay: "0",
          tuVongKhamNghiemTuThi: "0",
          tuVongNgay: null,
          tuVongThoiGian: null,
          tuVongNguyenNhan: null,
        }}
        onSubmit={handleFormSubmit}
        validationSchema={validationSchema}
      >
        {({
          touched,
          errors,
          setFieldValue,
          values,
          setValues,
          handleChange
        }) => (
          <Form className='flex-column overflow-hidden'>
            <Modal.Body>
              <Row className="mb-1">
                <Col xl={5} className='d-flex'>
                  <LabelRequired className='spaces min-w-175' label="Thời gian ra viện"/>
                  <DatePickerCustom
                      mode='date-time'
                      name="raVienNgay"
                      value={values?.raVienNgay}
                      setDateValue={date => {
                          setFieldValue('raVienNgay', date);
                      }}
                      errors={errors?.raVienNgay}
                      touched={touched?.raVienNgay}
                  />
                </Col>

                <Col xl={4} className='d-flex'>
                  <LabelRequired className='spaces min-w-140' label="Thời điểm tử vong" isRequired />
                  <DatePickerCustom
                      mode='date-time'
                      name="tuVongNgay"
                      value={values?.tuVongNgay}
                      setDateValue={date => {
                          setFieldValue('tuVongNgay', date);
                      }}
                      errors={errors?.tuVongNgay}
                      touched={touched?.tuVongNgay}
                      maxDate={new Date()}
                  />
                </Col>

                <Col xl={3}>
                  <FormCheck
                    className="ms-1 mt-3 spaces min-w-100"
                    label="Cấp giấy chứng tử"
                    type="checkbox"
                    name="tuVongDaCapGiay"
                    checked={values?.tuVongDaCapGiay === '1'}
                    onChange={e => setFieldValue('tuVongDaCapGiay', e.target.checked ? '1' : '0')}
                  />
                </Col>
              </Row>

              <Row className="mb-1">
                <Col xl={5} className='d-flex'>
                  <LabelRequired className='spaces min-w-175' label="Thời gian tử vong" isRequired />
                  <AutocompleteV2
                    options={[]}
                    searchFunction={getInpatientCategory}
                    searchObject={categoryCode.THOI_GIAN_TU_VONG}
                    name="tuVongThoiGian"
                    onChange={(option) => setFieldValue("tuVongThoiGian", option)}
                    value={values?.tuVongThoiGian}
                    errors={errors?.tuVongThoiGian}
                    touched={touched?.tuVongThoiGian}
                  />
                </Col>

                <Col xl={7} className='d-flex'>
                  <LabelRequired className='spaces W-140' label="Nguyên nhân" isRequired />
                  <AutocompleteV2
                    options={[]}
                    searchFunction={getInpatientCategory}
                    searchObject={categoryCode.NGUYEN_NHAN_TU_VONG}
                    name="tuVongNguyenNhan"
                    onChange={(option) => setFieldValue("tuVongNguyenNhan", option)}
                    value={values?.tuVongNguyenNhan}
                    errors={errors?.tuVongNguyenNhan}
                    touched={touched?.tuVongNguyenNhan}
                  />
                </Col>
              </Row>

              <div className="mb-1 d-flex w-100">
                <LabelRequired
                  label="Nguyên nhân chính"
                  className="spaces W-175"
                />
                <Row className="spaces pe-0 align-items-center position-relative flex-grow-1">
                  <ProvisonalDiagnosis
                    encounterDiagnosisValues={values}
                    encounterDiagnosisErrors={errors}
                    encounterDiagnosisTouched={touched}
                    listComorbidity={listComorbidity}
                    setListComorbidity={setListComorbidity}
                    icd10Field="tuVongNguyenNhanChinh"
                    onChange={(data: any) => setValues({
                      ...values,
                      ...data
                    })}
                    handleChangeEncounterDiagnosis={handleChange}
                    hasDiagnosisNonCoded={false}
                  />
                </Row>
              </div>

              <Row className="mb-1">
                <Col xl={5} className='d-flex'>
                  <LabelRequired className='spaces W-175' label="" />
                  <FormCheck
                    className="ms-1 mt-1 spaces min-w-100"
                    label="Khám nghiệm tử thi"
                    type="checkbox"
                    name="tuVongKhamNghiemTuThi"
                    checked={values?.tuVongKhamNghiemTuThi === '1'}
                    onChange={e => setFieldValue('tuVongKhamNghiemTuThi', e.target.checked ? '1' : '0')}
                  />
                </Col>
              </Row>

              <div className="mb-1 d-flex w-100">
                <LabelRequired
                  label="Chẩn đoán giải phẫu tử thi"
                  className="spaces W-175"
                />
                <Row className="spaces pe-0 align-items-center position-relative flex-grow-1">
                  <ProvisonalDiagnosis
                    encounterDiagnosisValues={values}
                    encounterDiagnosisErrors={errors}
                    encounterDiagnosisTouched={touched}
                    listComorbidity={listComorbidity}
                    setListComorbidity={setListComorbidity}
                    icd10Field="tuVongChanDoanGiaiPhau"
                    onChange={(data: any) => setValues({
                      ...values,
                      ...data
                    })}
                    handleChangeEncounterDiagnosis={handleChange}
                    hasDiagnosisNonCoded={false}
                  />
                </Row>
              </div>

              <Row className="mb-1">
                <Col xl={12} className='d-flex'>
                  <LabelRequired className='spaces W-175' label="Quá trình bệnh lý và diễn biến lâm sàng"/>
                  <TextField name="pathologicalProcessSummary" as="textarea" rows={3} 
                    className="resize-none flex-grow-1"
                  />
                </Col>
              </Row>

              <Row className="mb-1">
                <Col xs={12} className='d-flex'>
                  <LabelRequired 
                    className='spaces W-175' 
                    label="Tóm tắt kết quả CLS có giá trị chẩn đoán" 
                  />
                  <ParaclinicalSummaryField 
                    value={values?.paraclinicalSummary}
                    onChange={(value) => {
                        setFieldValue('paraclinicalSummary', value);
                    }}
                    patientInfo={{
                      visitId: patientInfo?.visitId,
                    }}
                    className="flex-1"
                  />
                </Col>
              </Row>

              <Row className="mb-1">
                <Col xs={12} className='d-flex'>
                  <LabelRequired className='spaces W-175' label="Phương pháp điều trị" />
                  <TextField name="treatmentMethod" as="textarea" rows={3} 
                    className="resize-none flex-grow-1"
                  />
                </Col>
              </Row>

              <Row className="mb-1">
                <Col xs={12} className='d-flex'>
                  <LabelRequired className='spaces W-175' label="Lời dặn của bác sĩ" />
                  <TextField name="doctorComment" as="textarea" rows={3} 
                    className="resize-none flex-grow-1"
                  />
                </Col>
              </Row>
            </Modal.Body>

            <Modal.Footer>
              {/* <Button className='btn-fill'>Cập nhật từ bệnh án</Button> */}
              <Button className='btn-danger min-w-80px' onClick={handleCloseDialog}>Đóng</Button>
              <Button className='btn-fill min-w-80px' type="submit">Lưu</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default ModalCapNhatThongTinTuVong